import { type PropsWithChildren } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

function VerbsColumn({ children }: PropsWithChildren) {
  return (
    <Box
      width="full"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      padding="s24"
      gap="s32"
    >
      {children}
    </Box>
  )
}

export default VerbsColumn
